import { createContext, useContext, useState } from "react";

export const translations = {
  fr: {
    nav: {
      services: "Services",
      dna: "Notre ADN",
      reviews: "Avis",
      faq: "FAQ",
      contact: "Contact",
      quote: "Devis gratuit",
      blog: "Conseils",
    },
    hero: {
      overline: "Nettoyage professionnel · Nice Ouest · Côte d'Azur",
      lines: ["L'art de la propreté,", "au service de vos", "établissements d'exception."],
      sub: "Service Plus entretient résidences de vacances, hôtels et locations Airbnb & Booking sur toute la Côte d'Azur. Une équipe de 10 professionnels, des solutions adaptées à chaque établissement.",
      ctaQuote: "Demander un devis",
      ctaServices: "Découvrir nos services",
      siret: "SIRET 753 964 691 00020",
      partners: "Partenaire officiel Interhome",
      stats: [
        { v: "10", l: "experts dédiés" },
        { v: "2025", l: "année de création" },
        { v: "24h", l: "réponse garantie" },
        { v: "7j/7", l: "disponibilité" },
      ],
    },
    marquee: ["Nice Ouest", "Hôtellerie de luxe", "Nettoyage Airbnb & Booking", "Partenaire Interhome", "Conciergerie", "Gestion locative", "10 collaborateurs de confiance"],
    manifesto: {
      overline: "Notre ADN",
      titleA: "Quatre engagements,",
      titleB: "une seule exigence.",
      chapters: [
        {
          n: "01",
          t: "L'excellence hôtelière, partout",
          d: "Chaque prestation suit un protocole inspiré des palaces : contrôle qualité systématique, finitions soignées, linge impeccable. Vos voyageurs retrouvent un établissement irréprochable, à chaque arrivée.",
        },
        {
          n: "02",
          t: "Un protocole sur mesure",
          d: "Aucun établissement ne se ressemble. Nous construisons avec vous un cahier des charges précis : fréquence, produits, priorités, consignes d'accès. Nos solutions s'adaptent à vos besoins, jamais l'inverse.",
        },
        {
          n: "03",
          t: "Réactivité 7j/7, clés en main",
          d: "Départ à 10h, arrivée à 16h ? Nos équipes orchestrent les rotations express entre chaque réservation, gèrent la remise des clés et coordonnent les check-ins. Vous louez, nous nous occupons du reste.",
        },
        {
          n: "04",
          t: "Un partenaire de confiance",
          d: "Société déclarée, équipe salariée de 10 professionnels, partenaire officiel Interhome. Service Plus vous apporte des garanties concrètes et une relation durable.",
        },
      ],
    },
    services: {
      overline: "Nos services",
      title: "Des solutions adaptées à chaque établissement",
      sub: "De la villa familiale à la résidence hôtelière, nous intervenons partout sur Nice et la Côte d'Azur.",
      cards: [
        {
          t: "Résidences de vacances",
          d: "Entretien complet de vos locations saisonnières entre chaque séjour.",
          bullets: ["Ménage complet & désinfection", "Remise en état entre voyageurs", "Signalement des dégradations"],
        },
        {
          t: "Hôtellerie haut de gamme",
          d: "Renfort de vos équipes ou externalisation complète du housekeeping.",
          bullets: ["Protocoles standards palace", "Personnel formé & encadré", "Contrôle qualité systématique"],
        },
        {
          t: "Rotation Airbnb & Booking",
          d: "Turnover express et blanchisserie de qualité hôtelière pour vos locations.",
          bullets: ["Intervention express 7j/7", "Gestion du linge de maison", "Photos de contrôle après passage"],
        },
        {
          t: "Gestion locative & conciergerie",
          d: "Une offre clés en main pour les propriétaires, en lien avec Interhome.",
          bullets: ["Gestion des clés & check-ins", "Coordination des voyageurs", "Suivi & reporting régulier"],
        },
      ],
      cta: "Demander ce service",
    },
    trust: {
      overline: "Confiance & garanties",
      title: "Une confiance vérifiée",
      sub: "Service Plus est une société déclarée, adossée aux réseaux professionnels de référence de l'immobilier et de la location saisonnière.",
      siretLabel: "Société déclarée",
      locationLabel: "13 rue Berthe Morisot, Nice Ouest",
      teamLabel: "Équipe de 10 professionnels salariés",
      partnerLabel: "Partenaire officiel",
    },
    testimonials: {
      overline: "Avis clients",
      title: "Ils nous confient leurs établissements",
      items: [
        {
          name: "Sophie M.",
          property: "Villa · Promenade des Anglais",
          text: "Une équipe d'une fiabilité rare. Mes voyageurs Airbnb mentionnent systématiquement la propreté dans leurs avis. Le turnover entre deux locations est impeccable, même en pleine saison.",
        },
        {
          name: "Laurent D.",
          property: "Appart'hôtel · Nice Mont Boron",
          text: "Nous avons externalisé tout notre housekeeping chez Service Plus. Le protocole est digne d'un palace et le contrôle qualité après chaque passage nous fait gagner un temps précieux.",
        },
        {
          name: "Emma R.",
          property: "Conciergerie · Airbnb Superhost",
          text: "La gestion des clés et la coordination avec Interhome sont fluides. Je recommande Service Plus à tous les propriétaires que j'accompagne sur la Côte d'Azur.",
        },
      ],
    },
    faq: {
      overline: "Questions fréquentes",
      title: "Toutes les réponses à vos questions",
      items: [
        {
          q: "Intervenez-vous en urgence entre deux locations ?",
          a: "Oui. Nos équipes sont organisées pour les rotations express : départ le matin, arrivée l'après-midi. Nous intervenons 7j/7, week-ends et jours fériés compris, selon votre planning de réservations.",
        },
        {
          q: "Gérez-vous le linge de maison ?",
          a: "Oui. Nous proposons une blanchisserie de qualité hôtelière : lavage, repassage et mise en place des draps et serviettes. Une option de location de linge est également disponible pour simplifier votre gestion.",
        },
        {
          q: "Pouvez-vous gérer les clés et les check-ins ?",
          a: "Absolument. Dans le cadre de notre offre de gestion locative, nous assurons la remise des clés, l'accueil des voyageurs, l'état des lieux d'entrée et de sortie, et la coordination avec vos plateformes (Airbnb, Booking, Interhome).",
        },
        {
          q: "Comment sont calculés vos tarifs ?",
          a: "Chaque devis est établi sur mesure selon la surface, la fréquence d'intervention et les prestations souhaitées (ménage, linge, conciergerie). Le devis est gratuit et vous est envoyé sous 24h.",
        },
        {
          q: "Que garantit votre partenariat Interhome ?",
          a: "Notre statut de partenaire officiel Interhome vous garantit le respect de standards professionnels stricts, une traçabilité complète et un recours en cas de litige.",
        },
        {
          q: "Quels types d'établissements entretenez-vous ?",
          a: "Locations Airbnb et Booking, villas, appartements, résidences de vacances, hôtels et appart'hôtels. Nos protocoles s'adaptent à chaque typologie de bien, du studio au palace.",
        },
        {
          q: "Êtes-vous une société déclarée et assurée ?",
          a: "Oui. Service Plus est une société déclarée (SIRET 753 964 691 00020) créée en 2025, basée au 13 rue Berthe Morisot à Nice Ouest, avec une équipe de 10 professionnels salariés et assurés.",
        },
      ],
    },
    contact: {
      overline: "Contact & devis",
      title: "Parlons de votre établissement",
      sub: "Décrivez-nous votre besoin : nous vous répondons sous 24h avec une proposition adaptée.",
      name: "Nom complet",
      namePh: "Votre nom",
      email: "Email",
      emailPh: "vous@exemple.fr",
      phone: "Téléphone",
      phonePh: "06 00 00 00 00",
      property: "Type d'établissement",
      propertyPh: "Sélectionnez",
      propertyOptions: ["Location Airbnb / Booking", "Villa / appartement", "Hôtel / appart'hôtel", "Résidence de vacances", "Autre"],
      service: "Service souhaité",
      servicePh: "Sélectionnez",
      serviceOptions: ["Nettoyage régulier", "Rotation entre voyageurs", "Gestion locative complète", "Blanchisserie / linge", "Autre"],
      message: "Votre message",
      messagePh: "Décrivez votre établissement, sa surface, la fréquence souhaitée...",
      submit: "Envoyer ma demande",
      sending: "Envoi en cours...",
      successTitle: "Demande envoyée !",
      successText: "Merci pour votre confiance. Notre équipe vous répond sous 24h ouvrées.",
      successToast: "Votre demande de devis a bien été envoyée.",
      errorToast: "Une erreur est survenue. Réessayez ou appelez-nous directement.",
      again: "Envoyer une autre demande",
      directTitle: "Contact direct",
      address: "13 rue Berthe Morisot, 06200 Nice Ouest",
      hours: "Disponible 7j/7 — réponse sous 24h",
    },
    blog: {
      overline: "Le journal Service Plus",
      title: "Conseils d'experts pour vos locations",
      sub: "Guides pratiques pour propriétaires et gestionnaires sur la Côte d'Azur.",
      read: "Lire l'article",
      more: "Tous les conseils",
      back: "Tous les conseils",
      min: "min de lecture",
      cta: "Besoin d'une équipe de confiance ?",
      ctaBtn: "Demander un devis gratuit",
    },
    chat: {
      title: "Assistant Service Plus",
      subtitle: "Réponses immédiates, 7j/7",
      welcome: "Bonjour et bienvenue chez Service Plus ! Je peux répondre à vos questions sur nos services de nettoyage, les rotations Airbnb, la gestion locative ou les devis. Comment puis-je vous aider ?",
      placeholder: "Écrivez votre question...",
      open: "Une question ?",
      error: "Désolé, une erreur est survenue. Contactez-nous au 07 67 47 32 93.",
    },
    footer: {
      tagline: "Nettoyage professionnel & gestion locative sur la Côte d'Azur.",
      contactTitle: "Contact",
      legalTitle: "Informations",
      navTitle: "Navigation",
      created: "Créée en 2025",
      team: "10 collaborateurs",
      rights: "Tous droits réservés.",
    },
  },
  en: {
    nav: {
      services: "Services",
      dna: "Our DNA",
      reviews: "Reviews",
      faq: "FAQ",
      contact: "Contact",
      quote: "Free quote",
      blog: "Tips",
    },
    hero: {
      overline: "Professional cleaning · Nice West · French Riviera",
      lines: ["The art of immaculate,", "at the service of your", "finest properties."],
      sub: "Service Plus maintains vacation rentals, hotels and Airbnb & Booking properties across the French Riviera. A team of 10 professionals, with solutions tailored to every property.",
      ctaQuote: "Request a quote",
      ctaServices: "Explore our services",
      siret: "SIRET 753 964 691 00020",
      partners: "Official Interhome partner",
      stats: [
        { v: "10", l: "dedicated experts" },
        { v: "2025", l: "year founded" },
        { v: "24h", l: "guaranteed reply" },
        { v: "7/7", l: "availability" },
      ],
    },
    marquee: ["Nice West", "Luxury hospitality", "Airbnb & Booking cleaning", "Interhome partner", "Concierge service", "Rental management", "10 trusted professionals"],
    manifesto: {
      overline: "Our DNA",
      titleA: "Four commitments,",
      titleB: "one standard of excellence.",
      chapters: [
        {
          n: "01",
          t: "Hotel-grade excellence, everywhere",
          d: "Every service follows a palace-inspired protocol: systematic quality checks, meticulous finishing, impeccable linen. Your guests arrive at a flawless property, every single time.",
        },
        {
          n: "02",
          t: "A tailor-made protocol",
          d: "No two properties are alike. We build a precise specification with you: frequency, products, priorities, access instructions. Our solutions adapt to your needs — never the other way around.",
        },
        {
          n: "03",
          t: "7/7 responsiveness, turnkey service",
          d: "Check-out at 10am, check-in at 4pm? Our teams orchestrate express turnovers between bookings, handle key handover and coordinate check-ins. You rent out, we take care of the rest.",
        },
        {
          n: "04",
          t: "A trusted partner",
          d: "A registered company, a salaried team of 10 professionals, official Interhome partner. Service Plus brings you concrete guarantees and a lasting relationship.",
        },
      ],
    },
    services: {
      overline: "Our services",
      title: "Solutions tailored to every property",
      sub: "From family villas to hotel residences, we operate across Nice and the French Riviera.",
      cards: [
        {
          t: "Vacation rentals",
          d: "Complete upkeep of your seasonal rentals between every stay.",
          bullets: ["Full cleaning & disinfection", "Reset between guests", "Damage reporting"],
        },
        {
          t: "Luxury hospitality",
          d: "Reinforce your teams or fully outsource your housekeeping.",
          bullets: ["Palace-standard protocols", "Trained & supervised staff", "Systematic quality control"],
        },
        {
          t: "Airbnb & Booking turnover",
          d: "Express turnover and hotel-grade laundry for your rentals.",
          bullets: ["Express service 7/7", "Household linen management", "Photo check after each visit"],
        },
        {
          t: "Rental management & concierge",
          d: "A turnkey offer for owners, in partnership with Interhome.",
          bullets: ["Key management & check-ins", "Guest coordination", "Regular follow-up & reporting"],
        },
      ],
      cta: "Request this service",
    },
    trust: {
      overline: "Trust & guarantees",
      title: "Verified trust",
      sub: "Service Plus is a registered company, backed by the leading professional networks in real estate and seasonal rentals.",
      siretLabel: "Registered company",
      locationLabel: "13 rue Berthe Morisot, Nice West",
      teamLabel: "Team of 10 salaried professionals",
      partnerLabel: "Official partner",
    },
    testimonials: {
      overline: "Client reviews",
      title: "They entrust us with their properties",
      items: [
        {
          name: "Sophie M.",
          property: "Villa · Promenade des Anglais",
          text: "A remarkably reliable team. My Airbnb guests systematically mention cleanliness in their reviews. The turnover between two stays is impeccable, even in high season.",
        },
        {
          name: "Laurent D.",
          property: "Aparthotel · Nice Mont Boron",
          text: "We outsourced our entire housekeeping to Service Plus. The protocol is worthy of a palace and the quality check after each visit saves us precious time.",
        },
        {
          name: "Emma R.",
          property: "Concierge · Airbnb Superhost",
          text: "Key management and coordination with Interhome are seamless. I recommend Service Plus to every owner I work with on the French Riviera.",
        },
      ],
    },
    faq: {
      overline: "Frequently asked questions",
      title: "All the answers to your questions",
      items: [
        {
          q: "Do you handle urgent turnovers between rentals?",
          a: "Yes. Our teams are organised for express turnovers: morning check-out, afternoon check-in. We operate 7 days a week, including weekends and public holidays, according to your booking calendar.",
        },
        {
          q: "Do you manage household linen?",
          a: "Yes. We offer hotel-grade laundry: washing, ironing and setup of sheets and towels. A linen rental option is also available to simplify your operations.",
        },
        {
          q: "Can you manage keys and check-ins?",
          a: "Absolutely. As part of our rental management offer, we handle key handover, guest welcome, check-in and check-out inspections, and coordination with your platforms (Airbnb, Booking, Interhome).",
        },
        {
          q: "How is your pricing calculated?",
          a: "Every quote is tailored to the surface, service frequency and requested tasks (cleaning, linen, concierge). The quote is free and sent to you within 24 hours.",
        },
        {
          q: "What does your Interhome partnership guarantee?",
          a: "Our official Interhome partner status guarantees strict professional standards, full traceability and recourse in case of dispute.",
        },
        {
          q: "Which types of properties do you maintain?",
          a: "Airbnb and Booking rentals, villas, apartments, vacation residences, hotels and aparthotels. Our protocols adapt to every property type, from studio to palace.",
        },
        {
          q: "Are you a registered and insured company?",
          a: "Yes. Service Plus is a registered company (SIRET 753 964 691 00020), founded in 2025, based at 13 rue Berthe Morisot in Nice West, with a team of 10 salaried and insured professionals.",
        },
      ],
    },
    contact: {
      overline: "Contact & quote",
      title: "Let's talk about your property",
      sub: "Tell us about your needs: we reply within 24 hours with a tailored proposal.",
      name: "Full name",
      namePh: "Your name",
      email: "Email",
      emailPh: "you@example.com",
      phone: "Phone",
      phonePh: "+33 6 00 00 00 00",
      property: "Property type",
      propertyPh: "Select",
      propertyOptions: ["Airbnb / Booking rental", "Villa / apartment", "Hotel / aparthotel", "Vacation residence", "Other"],
      service: "Service needed",
      servicePh: "Select",
      serviceOptions: ["Regular cleaning", "Turnover between guests", "Full rental management", "Laundry / linen", "Other"],
      message: "Your message",
      messagePh: "Describe your property, its size, the desired frequency...",
      submit: "Send my request",
      sending: "Sending...",
      successTitle: "Request sent!",
      successText: "Thank you for your trust. Our team will reply within 24 business hours.",
      successToast: "Your quote request has been sent.",
      errorToast: "Something went wrong. Please try again or call us directly.",
      again: "Send another request",
      directTitle: "Direct contact",
      address: "13 rue Berthe Morisot, 06200 Nice West",
      hours: "Available 7/7 — reply within 24h",
    },
    blog: {
      overline: "The Service Plus journal",
      title: "Expert tips for your rentals",
      sub: "Practical guides for owners and property managers on the French Riviera.",
      read: "Read article",
      more: "All articles",
      back: "All articles",
      min: "min read",
      cta: "Need a team you can trust?",
      ctaBtn: "Request a free quote",
    },
    chat: {
      title: "Service Plus Assistant",
      subtitle: "Instant answers, 7 days a week",
      welcome: "Hello and welcome to Service Plus! I can answer your questions about our cleaning services, Airbnb turnovers, rental management or quotes. How can I help?",
      placeholder: "Type your question...",
      open: "Any questions?",
      error: "Sorry, something went wrong. Call us at +33 7 67 47 32 93.",
    },
    footer: {
      tagline: "Professional cleaning & rental management on the French Riviera.",
      contactTitle: "Contact",
      legalTitle: "Information",
      navTitle: "Navigation",
      created: "Founded in 2025",
      team: "10 team members",
      rights: "All rights reserved.",
    },
  },
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState("fr");
  const t = translations[lang];
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
